import { IFormConfigQualifierAttribute } from "../../service/formconfiguration/FormConfigQualifierAttribute";
import { IQualiferService } from "../../service/formconfiguration/QualifierService";

export default class CreateFormConfigQualifierAttributeInteractor {
  private qualifierService: IQualiferService;

  constructor(qualifierService: IQualiferService) {
    this.qualifierService = qualifierService;
  }

  async execute(
    qualifierCode: string,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ) {
    await this.qualifierService.createFormConfigQualifierAttribute(
      qualifierCode,
      formConfigQualifierAttribute
    );
  }
}
